<template>
  <div class="columns" style="text-align: center">
    <div class="data-style">
      <el-popover
        v-for="(item, index) in dataList"
        v-bind:key="index"
        placement="top-end"
        :trigger="valTrigger"
        :content="item.value"
        :disabled="item.disabled"
      >
        <div
          slot="reference"
          class="data-list"
          :style="[dataStyle || item.dataStyle]"
        >
          <div>{{ item.label || '' }}</div>
          <div class="value" :style="[item.valStyle]">{{ item.value }}</div>
        </div>
      </el-popover>
    </div>
    <el-popover
      placement="top-start"
      :width="popoverWidth"
      :trigger="trigger"
      :disabled="disabled"
    >
      <component
        :is="componentName"
        :scope="scope"
        :table-data="tableData"
        v-bind="$attrs"
        v-on="$listeners"
      ></component>
      <ig-icon v-if="componentName" slot="reference" name="chakan" :style="[iconStyle]"></ig-icon>
    </el-popover>
  </div>
</template>
<script>
import customComponent from '@/components/tools/customComponent';
import account from './index.js';
export default {
  props: {
    tableData: Object,
    scope: Object
  },
  data() {
    return {};
  },
  computed: {
    trigger() {
      return this.tableData.trigger || 'click';
    },
    valTrigger() {
      return this.tableData.valTrigger || 'hover';
    },
    popoverWidth() {
      return this.tableData.popoverWidth || '400';
    },
    componentName() {
      let { scope, tableData } = this;
      if (!(scope && tableData)) return false;
      return tableData.componentName || false;
    },
    dataList() {
      let { scope, tableData } = this;
      if (scope && tableData && tableData.dataList) {
        return tableData.dataList(scope.row[tableData.bind], scope.row);
      }
      return []
    },
    dataStyle() {
      let { scope, tableData } = this;
      if (!(scope && tableData)) return false;
      return tableData.dataStyle;
    },
    iconStyle() {
      let { scope, tableData } = this;
      if (!(scope && tableData)) return false;
      return tableData.iconStyle;
    },
    disabled() {
      if (this.tableData.disabled !== undefined) {
        return this.tableData.disabled;
      }
      return false;
    }
  },
  watch: {},
  mounted() {},
  methods: {},
  components: { ...account, customComponent }
};
</script>
<style lang="scss" scoped>
.data-list {
  display: flex;
  align-items: center;
}
.data-style {
  width: 80%;
  .value {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.columns {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 10px;
}
</style>
